/* import __COLOCATED_TEMPLATE__ from './copilot-seats-accordion-section.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

interface Args {
  accordion: any;
}

export default class CopilotSeatsAccordionSection extends Component<Args> {
  @service declare appService: any;

  get copilotSeatCount() {
    return this.appService.app.humanAdminsWithCopilotSeat.length;
  }

  get subheaderTranslationKey() {
    if (this.appService.app.hasStandalonePlatform('zendesk')) {
      return 'standalone.deploy.common.copilot-seats.subheader.zendesk';
    }

    if (this.appService.app.hasStandalonePlatform('salesforce')) {
      return 'standalone.deploy.common.copilot-seats.subheader.salesforce';
    }

    return 'standalone.deploy.common.copilot-seats.subheader.generic';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Common::CopilotSeatsAccordionSection': typeof CopilotSeatsAccordionSection;
  }
}
